@if (allowedValues) {
  <mat-form-field [formGroup]="paramsGroup" class="any-array-filter">
    <mat-label>Value</mat-label>
    <mat-select formControlName="value" multiple>
      @for (option of allowedValues; track option) {
        <mat-option [value]="option">{{ option }}</mat-option>
      }
    </mat-select>
    @if (paramsGroup.get('value')?.hasError('required')) {
      <mat-error>This field is required</mat-error>
    }
  </mat-form-field>
} @else {
  <app-text-array-filter [paramsGroup]="paramsGroup"></app-text-array-filter>
}
